import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  items = [];

  init(items = []) {
    this.items = items;
  }

  has(arg) {
    return !!this.items.find(i => i === arg);
  }

  hasAny(...args) {
    if (!args) return true;
    if (!args.length) return true;
    return !!args.find(i => this.has(i));
  }

  hasAll(...args) {
    if (!args?.length) return true;
    return !args.find(i => !this.has(i));
  }
}
